import { render, staticRenderFns } from "./SRIOItem.vue?vue&type=template&id=a23e6456"
import script from "./SRIOItem.vue?vue&type=script&lang=js"
export * from "./SRIOItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports